import smartApi from '@/apis/smart.api';
import { localStorageService } from '@/services/storage.service';
import layerManager from '@/services/layer.manager';
import * as layerNames from '@/services/layerName';
import eventBus from '@/services/eventBus.service';
export default class SmartGuide {
  constructor(panoPromise, dealerId, sceneId) {
    this.dealerId = dealerId;
    this.kankanPano = null;
    this.intervalId = null;
    this.onlyOneIntervalId = null;
    this.taskExecutor = null;
    this.isPause = false;
    this.panoPromise = panoPromise;
    this.index = 0;
    this.sceneId = sceneId;
    this.startFly();
  }
  startFly() {
    localStorageService.removeItem('isFromIm');
    this.panoPromise.then((panoInstance) => {
      panoInstance.loadedPromise &&
        panoInstance.loadedPromise
          .then(() => {
            this.kankanPano = panoInstance;
            const panos = panoInstance.kankan.Scene.panos.list;
            if (panos.length === 1) {
              this.kankanPano.kankan.Camera.flyToPano(panos[0].id);
              this.onlyOneIntervalId = setInterval(() => {
                this.fromImBackFn();
              }, 2000);
              return;
            }
            const player = this.kankanPano.kankan.core.get('Player');
            smartApi
              .getGuideSetting(this.dealerId, this.sceneId)
              .then((res) => {
                if (res.pointLine.length) {
                  this.realFlyFunc(player, res);
                  if (res.pointLine.length >= 2) {
                    this.intervalId = setInterval(() => {
                      this.fromImBackFn();
                      this.realFlyFunc(player, res);
                    }, 6500);
                  }
                }
              });
          })
          .catch((r) => {
            console.log('errer=>', r);
          });
    });
  }
  fromImBackFn() {
    const val = localStorageService.getItem('isFromIm');
    if (val) {
      layerManager.open(layerNames.OFFCALLMODAL, {
        title: '',
        content: '是否继续本次导览?',
        showCancel: true,
        cancelText: '取消',
        okText: '继续',
        onOk: () => {
          eventBus.$emit('getMuted');
          localStorageService.removeItem('isFromIm');
        },
        onCancel: () => {
          eventBus.$emit('toggleGuide', 'pause');
          localStorageService.removeItem('isFromIm');
        },
      });
    }
  }
  realFlyFunc(player, res) {
    if (this.isPause) return;
    const pointLines = res.pointLine;
    // 执行方法并传入当前数组元素
    const panoId = pointLines[this.index % pointLines.length].panoId;
    const target = this.kankanPano.kankan.Scene.panos.list.find(
      (o) => o.id === panoId,
    );
    this.getLookVector(player, target.position.clone(), 2000)
      .then(() => {
        this.kankanPano.kankan.Camera.flyToPano(panoId);
      })
      .catch(() => {
        console.log('初始化失败');
        return;
      });
    // this.kankanPano.kankan.Camera.flyToPano(panoId);
    // 索引递增并取模以循环数组
    this.index = (this.index + 1) % pointLines.length;
  }
  getLookVector(player, position, time) {
    return new Promise((resolve, reject) => {
      const lookPos = player.cameraControls.activeControl.lookVector;
      const initPos = { x: lookPos.x, y: lookPos.y, z: lookPos.z };
      function update() {
        player.cameraControls.activeControl.lookAt(initPos);
      }
      const t = new TWEEN.Tween(initPos);
      t.to(position, time)
        .easing(TWEEN.Easing.Linear.None)
        .onUpdate(update)
        .onComplete(() => {
          resolve();
        });
      t.start();
    });
  }
  cancelGuide() {
    clearInterval(this.intervalId);
    this.intervalId = null;
    clearInterval(this.onlyOneIntervalId);
    this.onlyOneIntervalId = null;
    localStorageService.removeItem('isFromIm');
  }
  changePause(state) {
    this.isPause = state;
  }
}
